import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges
} from '@angular/core';
import { DrawMethod } from '@core/models/raffle.model';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-product-end-prize',
  templateUrl: './product-end-prize.component.html',
  styleUrls: ['./product-end-prize.component.scss']
})
export class ProductEndPrizeComponent implements OnChanges, OnDestroy {
  @Input() endPrize: string;
  @Input() endAt: Date;
  @Input() endPrizeDescription: string;
  @Input() endPrizeInfo: string;
  @Input() drawMethod: DrawMethod;
  @Input() facebookUrl: string;
  @Input() youtubeUrl: string;

  @Output() infoEvent = new EventEmitter<void>();

  daysLeft: number;
  hoursLeft: number;
  minutesLeft: number;
  showTimerSeparator = true;
  drawMethods = DrawMethod;

  private blinkInterval: ReturnType<typeof setInterval>;
  private calculateTimeInterval: ReturnType<typeof setInterval>;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.endAt) {
      this.calculateTimeLeft();

      this.blinkInterval = setInterval(() => {
        this.showTimerSeparator = !this.showTimerSeparator;
      }, 500);

      this.calculateTimeInterval = setInterval(() => {
        this.calculateTimeLeft();
      }, 60000);
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.blinkInterval);
    clearInterval(this.calculateTimeInterval);
  }

  private calculateTimeLeft() {
    const targetDate = dayjs(this.endAt);
    const now = dayjs();
    this.daysLeft = targetDate.diff(now, 'day');
    this.hoursLeft = targetDate.diff(now, 'hour') % 24;
    this.minutesLeft = targetDate.diff(now, 'minute') % 60;
  }
}
